module.exports = __webpack_public_path__ + "media/AUDIO 17.b2483dc1.mp3";